import { html } from 'omni-ui';
import { mergeClass, Om2FormFieldBase, SHARED_FIELD } from './common/base.js';

/**
 * Render a boolean input
 */
export class Om2FormFieldBoolean extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'Boolean Input',
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        tooltip: SHARED_FIELD,
        class: SHARED_FIELD,
        default: {
          title: 'Default Value',
          type: 'boolean',
        },
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: {
          title: 'Read Only',
          type: 'boolean',
          tooltip:
            "Rendered as disabled since HTML checkboxes can't be readonly",
        },
      },
    },
  };

  render() {
    return html`
      <input
        type="checkbox"
        class=${mergeClass('checkbox', this.schema.class)}
        .name="${this.key}"
        .value=${this.data ?? this.schema.default ?? ''}
        ?checked=${this.data}
        ?required=${this.schema.required}
        ?disabled=${this.schema.disabled ||
        this.schema.readonly ||
        this.context?.readonly ||
        this._isHidden()}
      />
    `;
  }
}

Om2FormFieldBoolean.register('boolean');
